import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../../environments/environment';
import { AuthenticationService, TokensService } from '../../services';
 
@Injectable()
export class ClientService {

    private restURL = environment.apiURL + 'clients/';
    private restURLUsers = environment.apiURL + 'users/';
    private restURLTokens = environment.apiURL + 'tokens/';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }

    getAvailableRoles() {
        return this.http.get(this.restURLTokens + 'roles', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })

            .catch((error: any) => {
                return Observable.throw(new Error("Roles not loadable"));
            });
    }

    removeRole(guid: string, role: string) {
        return this.http.delete(this.restURL + guid + '/roles/' + role, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not remove role from client"));
            });

    }

    unlock(guid: string) {
        return this.http.put(this.restURL + guid + '/unlock', '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not lock client"));
            });

    }

    lock(guid: string) {
        return this.http.put(this.restURL + guid + '/lock', '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not lock client"));
            });

    }

    deleteClient(guid: string) {
        return this.http.delete(this.restURL + guid,  {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete client"));
            });

    }

    addClient(name: string, configId: string) {
        let client:any = {};
        client.name = name;
        client.configId = configId;
        return this.http.post(this.restURL, client, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not create client"));
            });

    }

    addRole(guid: string, role: string) {
        return this.http.post(this.restURL + guid + '/roles/' + role, '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add role to client"));
            });

    }

    removeUser(guid: string, userId: string) {
        return this.http.delete(this.restURL + guid + '/users/' + userId,  {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not remove user from client"));
            });

    }

    addUser(guid: string, userId: string) {
        return this.http.post(this.restURL + guid + '/users/' + userId, null, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add user to client"));
            });

    }

    getRoles(guid: string) {
        return this.http.get(this.restURL + guid + '/roles', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let roles = res.json();
                return roles;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load client roles"));
            });
    }

    getAllUsers() {
        return this.http.get(this.restURLUsers, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let users = res.json();
                return users;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load users"));
            });
    }

    getUsers(guid: string) {
        return this.http.get(this.restURL + guid + '/users', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let users = res.json();
                return users;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load client users"));
            });
    }

    getClient(guid: string) {
        return this.http.get(this.restURL + guid, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let client = res.json();
                return client;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load client detail"));
            });
    }

    getClients(locked: string, deleted: string) {
        let filter: string = "";
        if (locked != null) {
            filter = "?locked=" + locked;
        }
        if (deleted != null) {
            if (filter == "") {
                filter = "?deleted=" + deleted;
            } else {
                filter = filter + "&deleted=" + deleted;
            }
        }
        return this.http.get(this.restURL + filter, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let clients = res.json();
                return clients;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load clients"));
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/clients/services/client.service.ts